module.exports = __webpack_public_path__ + "static/media/nav-icon2.cf332899.svg";